import React from 'react';
import { useTranslation } from 'react-i18next';

import { TableContainer } from 'app/WMS/styles/styles';

import { Table } from 'components/Tools/Table';

import { ICollectTable, ICollectData } from '../../../types';

const CollectTable: React.FC<ICollectTable> = ({ collectData }) => {
  const { t } = useTranslation();

  return (
    <TableContainer>
      <Table<ICollectData>
        columns={[
          {
            title: String(t('screens.commom.order')),
            orderable: true,
            display: 'notEmpty',
            type: 'string',
            props: ['codigoPedido'],
            cssProps: {
              width: '1%',
            },
            cssTitle: {
              width: '1%',
            },
          },
          {
            title: `${t('screens.commom.quantity')}`,
            type: 'string',
            orderable: true,
            display: 'notEmpty',
            props: ['quantidade'],
            cssProps: {
              width: '1%',
            },
            cssTitle: {
              width: '1%',
            },
          },
          {
            title: `${t('screens.manualOrder.date')} ${t(
              'screens.orderFollowUp.planning'
            )}`,
            type: 'datetime',
            orderable: true,
            display: 'notEmpty',
            props: ['dataCriacao'],
            cssProps: {
              width: '0.2%',
            },
          },
        ]}
        rows={collectData}
        exportList
      />
    </TableContainer>
  );
};
export default CollectTable;
